module.exports = __webpack_public_path__ + "img/banner4.a0412c11.png";